import { useEffect } from "react";
import { X } from "lucide-react";

const COLORS = ["#FF6B6B", "#FFD93D", "#6BCB77", "#4D96FF", "#B983FF", "#FFD54F"];

export default function Celebration({ open, onClose, kidName, points = 0, stars = 0, achievements = [], nextEpisode = null }) {
  useEffect(() => {
    if (!open) return;
    if (nextEpisode) return; // auto-close disabled when there is a next episode CTA
    const t = setTimeout(() => onClose(), 4200);
    return () => clearTimeout(t);
  }, [open, onClose, nextEpisode]);

  if (!open) return null;

  const pieces = Array.from({ length: 28 });

  return (
    <div
      data-testid="celebration-modal"
      className="fixed inset-0 z-[70] bg-[#243B53]/40 backdrop-blur-sm flex items-center justify-center px-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative card-soft bg-white w-full max-w-md p-8 text-center animate-pop-in overflow-hidden"
      >
        {/* Confetti */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          {pieces.map((_, i) => {
            const left = Math.random() * 100;
            const dx = (Math.random() - 0.5) * 120;
            const delay = Math.random() * 0.6;
            const color = COLORS[i % COLORS.length];
            return (
              <span
                key={i}
                className="confetti-piece"
                style={{
                  left: `${left}%`,
                  background: color,
                  animationDelay: `${delay}s`,
                  "--dx": `${dx}px`,
                }}
              />
            );
          })}
        </div>

        <button
          data-testid="celebration-close-btn"
          onClick={onClose}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#FFF9ED] flex items-center justify-center text-[#243B53]"
        >
          <X size={18} />
        </button>

        <div className="text-5xl relative">🎉</div>
        <h2 className="mt-3 text-2xl font-extrabold text-[#243B53]">
          Muito bem{kidName ? `, ${kidName}` : ""}!
        </h2>
        <p className="text-sm text-[#243B53]/70">Você concluiu esta atividade!</p>

        <div className="mt-6 grid grid-cols-2 gap-3">
          <div className="rounded-2xl p-4 bg-[#FFF9ED] border border-[#FFD54F]/40">
            <div className="text-xs font-bold text-[#243B53]/60">Pontos</div>
            <div className="text-2xl font-extrabold text-[#D9A441]" data-testid="celebration-points">+{points}</div>
          </div>
          <div className="rounded-2xl p-4 bg-[#FFF9ED] border border-[#5DADE2]/30">
            <div className="text-xs font-bold text-[#243B53]/60">Estrelas</div>
            <div className="text-2xl font-extrabold text-[#5DADE2]" data-testid="celebration-stars">
              +{stars} <span className="text-lg">⭐</span>
            </div>
          </div>
        </div>

        {achievements?.length > 0 && (
          <div className="mt-5">
            <div className="text-xs font-bold text-[#243B53]/60 mb-2">Novas conquistas!</div>
            <div className="flex flex-wrap justify-center gap-2">
              {achievements.map((a) => (
                <div
                  key={a.key}
                  data-testid={`celebration-achievement-${a.key}`}
                  className="rounded-full px-3 py-1 bg-white border border-[#FFD54F] font-bold text-sm text-[#243B53]"
                >
                  <span className="mr-1">{a.emoji}</span>{a.label}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mt-6 h-1 rounded-full rainbow-strip" />

        {nextEpisode ? (
          <button
            data-testid="celebration-next-episode-btn"
            onClick={onClose}
            className="btn-primary mt-6 w-full"
          >
            ▶️ Assistir próximo episódio · {nextEpisode.title}
          </button>
        ) : (
          <button
            data-testid="celebration-continue-btn"
            onClick={onClose}
            className="btn-primary mt-6 w-full"
          >
            Continuar
          </button>
        )}
      </div>
    </div>
  );
}
